"use strict";
/*
 * Created on Thu Feb 07 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AdtFlag_1 = require("../../core/model/AdtFlag");
/**
 * Product flag is related to {@link WindowItem} validation
 *
 * @author JMt
 */
// tslint:disable:max-classes-per-file


var WindowOverviewFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(WindowOverviewFlag, _AdtFlag_1$AdtFlag);

  function WindowOverviewFlag() {
    _classCallCheck(this, WindowOverviewFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowOverviewFlag).apply(this, arguments));
  }

  _createClass(WindowOverviewFlag, null, [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(WindowOverviewFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(WindowOverviewFlag, data);
    }
  }]);

  return WindowOverviewFlag;
}(AdtFlag_1.AdtFlag);

exports.WindowOverviewFlag = WindowOverviewFlag;
WindowOverviewFlag.TAG = '__WindowItemFlag__';
/**
 * Flag indicating the values in windowItem vary
 */

var VaryingDiscount =
/*#__PURE__*/
function (_WindowOverviewFlag) {
  _inherits(VaryingDiscount, _WindowOverviewFlag);

  function VaryingDiscount() {
    _classCallCheck(this, VaryingDiscount);

    return _possibleConstructorReturn(this, _getPrototypeOf(VaryingDiscount).apply(this, arguments));
  }

  _createClass(VaryingDiscount, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return VaryingDiscount;
}(WindowOverviewFlag);

exports.VaryingDiscount = VaryingDiscount;
VaryingDiscount.TAG = WindowOverviewFlag.register(VaryingDiscount);
/**
 * Flag indicating the values in windowItem vary
 */

var VaryingPrice =
/*#__PURE__*/
function (_WindowOverviewFlag2) {
  _inherits(VaryingPrice, _WindowOverviewFlag2);

  function VaryingPrice() {
    _classCallCheck(this, VaryingPrice);

    return _possibleConstructorReturn(this, _getPrototypeOf(VaryingPrice).apply(this, arguments));
  }

  _createClass(VaryingPrice, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return VaryingPrice;
}(WindowOverviewFlag);

exports.VaryingPrice = VaryingPrice;
VaryingPrice.TAG = WindowOverviewFlag.register(VaryingPrice);